// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"7bc9c415","99":"fe82da50","178":"7e78b169","181":"58cee3ce","184":"8cf4c87e","218":"47e3ddca","345":"8d631ba7","385":"a13f45d2","453":"938656df","767":"c28c8aef"}[chunkId] + ".chunk.js";
};